export default "__VITE_PUBLIC_ASSET__761be41f__"